import React from "react";
import { ModalHeader } from "reactstrap";
import Title from "../title";

export const ServicesTitle = () => {
  return (
    <ModalHeader className="mx-4">
      <Title
        title="Add Service or Product"
        subtitle=""
        subtitlestyle="ctf-tx-secondary"
      />
    </ModalHeader>
  );
};
